export const openChat = () => {
  if (!window.drift) return;
  window.drift.on('ready', (api) => {
    api.showWelcomeMessage();
  });
};



// WEBPACK FOOTER //
// ./src/utilities.js